<template>
  <div class="ds-custom-query-logic-group" :class="{'ds-custom-query-logic-group__expand':expand}">
    <span class="ds-custom-query-logic-group-join" @click="changeLogic" @mousedown.prevent>
      {{getLogicStr()}}
    </span>
    <span class="ds-custom-query-logic-group-expand" @mousedown.prevent v-if="!data.isRoot">
      <DsfIcon name="jia" v-if="!expand" @click.stop="expandHandler" title="展开"></DsfIcon>
      <DsfIcon name="jian" v-else @click.stop="expandHandler" title="折叠"></DsfIcon>
    </span>
    <div class="ds-custom-query-logic-group-box" v-show="expand">
      <div class="ds-custom-query-logic-group-brackets">
      </div>
      <div class="ds-custom-query-logic-items">
        <template v-for="(item,$index) in data.items">
          <DsfCustomQuerySplit :key="item.$hash+'—before'" :data="item" pos="before"></DsfCustomQuerySplit>
          <DsfCustomQueryLogicNode :key="item.$hash" :data="item"></DsfCustomQueryLogicNode>
          <DsfCustomQuerySplit v-if="$index==data.items.length-1" :key="item.$hash+'-after'" :data="item" pos="after"></DsfCustomQuerySplit>
        </template>
      </div>
    </div>
    <div class="ds-custom-query-logic-group-box-contract" v-show="!expand" @click.stop="expandHandler">
      <span title="展开">{{data.items.length+'个子条件'}}</span>
    </div>
  </div>

</template>
<script>
const LOGIC = {
  and: "与",
  or: "或"
};
// import DsfCustomQueryItem from "./customQueryItem.vue";
// import DsfCustomQueryLogicNode from "./customQueryLogicNode";
export default {
  name: "DsfCustomQueryLogicGroup",
  inject: {
    $queryLogic:{
      default:null
    },
    $queryTree: {
      default: null
    },
    $queryNode: {
      default: null
    }
  },
  props: {
    data: {
      type: Object,
      default() {
        return {
          logic: LOGIC.and,
          items: []
        };
      }
    }
  },
  data() {
    return {
      expand:true
    };
  },
  computed: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    changeLogic() {
      this.data.logic = this.data.logic == "or" ? "and" : "or";
    },
    getLogicStr() {
      return LOGIC[this.data.logic];
    },
    expandHandler(){
      this.expand=!this.expand;
    }
  },
  watch:{
    'data.items'(){
      this.$nextTick(()=>{
        this.$queryTree.buildTreeRelation()
      })
    }
  }
};
</script>